module.exports = __webpack_public_path__ + "img/LOGO_VHS_blau_rot.2380dbfd.jpg";